import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Flex } from "rebass";
import { FaPlus } from "react-icons/fa";

import { showModal } from "../../../store/modules/modal/actions";
import { getIsAnonymous } from "../../../store/modules/session/selectors";

export const AddRecordButton: React.FC = () => {
  const isAnonymous = useSelector(getIsAnonymous);
  const dispatch = useDispatch();
  const dispatchAddFilesModal = useCallback(() => {
    dispatch(showModal("addFiles"));
  }, [dispatch]);

  return isAnonymous === false
    ? (
      <Flex
        as="button"
        type="button"
        justifyContent="center"
        alignItems="center"
        width="33px"
        height="33px"
        mr="10px"
        color="wild-blue"
        bg="sp-gray"
        css="border-radius: 50%;"
        onClick={dispatchAddFilesModal}
      >
        <FaPlus display="block" size="13" />
      </Flex>
    )
    : null;
};
